// extracted by mini-css-extract-plugin
export default {"title":"ForgotPassword_title__AUQCn","text":"ForgotPassword_text__MzGh7"};